import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker?: string;
  title: ReactNode;
  desc?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({ kicker, title, desc, action, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center md:justify-center text-center" : ""
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {kicker ? (
          <div
            className={`rule-label mb-3 flex items-center gap-2 text-accent-700 ${
              isCenter ? "justify-center" : ""
            }`}
          >
            <span className="h-px w-6 bg-accent-500" />
            {kicker}
          </div>
        ) : null}
        <h2 className="font-heading text-2xl font-semibold leading-snug tracking-tight text-foreground-950 md:text-[30px]">
          {title}
        </h2>
        {desc ? <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p> : null}
      </div>
      {action ? <div className="flex shrink-0 items-center gap-3">{action}</div> : null}
    </div>
  );
}